module.exports = __webpack_public_path__ + "WorkerPoolIcon.46a9782f389c3353e7270a5ce01b62f9.hashedasset.svg";